import whitelabelService from "../../../../services/whitelabel/whitelabel.service";
import SectionTitle from "../../../Shared/SectionTitle/SectionTitle.component";
import {
  BigPhoto,
  BigPhotoWrapper,
  Container,
  IconWrapper,
  Item,
  Photo,
  SquarePhotoDescription,
  Title,
  Topic,
  TopicIcon,
  Topics,
  TopicWrapper,
  Wrapper,
} from "./Operation.styles";

export default function Operation() {
  const whitelabelCompany = whitelabelService
    .getWBDataCompany();

  return (
    <>
      <Container id="operation">
        <SectionTitle text="Como Funciona?" />
        <Wrapper>
          <Item>
            <Photo src="images/operation/engage.png" />
            <Title>Contrate sua vistoria digital</Title>
            <SquarePhotoDescription>
              Insira a placa da sua moto ou carro no espaço indicado em nossa página. Realize seu cadastro de acordo com as informações solicitadas, é bem rápido! O pagamento pode ser feito por PIX, cartão de crédito ou boleto.
            </SquarePhotoDescription>
          </Item>
          <Item>
            <Photo src="images/operation/doit.png" />
            <Title>Faça sua vistoria digital</Title>
            <SquarePhotoDescription>
              Após realizar o pagamento, você receberá pelo WhatsApp o link para iniciar a vistoria. Clique no link e siga as orientações indicadas. Muita atenção aos ângulos indicados, se a foto está nítida, e se as informações necessárias foram captadas corretamente seguindo as recomendações solicitadas.
            </SquarePhotoDescription>
          </Item>
          <Item>
            <Photo src="images/operation/digital-report.png" />
            <Title>Receba o seu laudo</Title>
            <SquarePhotoDescription>
              Ao finalizar o processo, sua vistoria será analisada pela nossa plataforma. Caso todas as fotos estejam corretas, sem nenhum erro, em até 24 horas você receberá o relatório. Caso nossa plataforma aponte algum problema, você receberá um novo link para realizar uma nova vistoria e o novo relatório será entregue em até 24h, a partir do momento da finalização.
            </SquarePhotoDescription>
          </Item>
          <Item>
            <Photo src="images/operation/send.png" />
            <Title>Envie para o seu consórcio</Title>
            <SquarePhotoDescription>
              O relatório final será enviado para seu e-mail de cadastro. Pronto! Agora é só encaminha-lo ao {whitelabelCompany.title} para dar continuidade ao seu processo de consórcio. Em caso de dúvida envie um e-mail para contato@infovist.com.br
            </SquarePhotoDescription>
          </Item>
        </Wrapper>
        <TopicWrapper>
          <BigPhotoWrapper>
            <BigPhoto src="images/operation/sofa.png" />
          </BigPhotoWrapper>
          <Topics>
            <Topic>
              <IconWrapper>
                <TopicIcon src="images/operation/topics/time.png" />
              </IconWrapper>
              <div>
                Totalmente digital,<br />fácil e rápido.
              </div>
            </Topic>
            <Topic>
              <IconWrapper>
                <TopicIcon src="images/operation/topics/payment.png" />
              </IconWrapper>
              <div>
                Mais opções nas formas<br />de pagamento.
              </div>
            </Topic>
            <Topic>
              <IconWrapper>
                <TopicIcon src="images/operation/topics/mobile.png" />
              </IconWrapper>
              <div>
                Aplicativo disponível<br />para todos os celulares.
              </div>
            </Topic>
          </Topics>
        </TopicWrapper>
      </Container>
    </>
  );
}